export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.qrmenus.in/api/";
export const IMAGE_BASE_URL =
  process.env.REACT_APP_IMAGE_BASE_URL || "https://api.qrmenus.in";

// export const API_BASE_URL=https://stage-api.qrmenus.in/api/
// export const IMAGE_BASE_URL=https://stage-api.qrmenus.in
